import register from '@kpsys/angularjs-register';

import recordDetailPathFilter from './record-detail-path.filter';
import bytesFilter from './bytes';
import charactersFilter from './characters';
import comma2decimalFilter from './comma2decimal';
import decimal2commaFilter from './decimal2comma';
import defaultFilter from './default';
import encodeUriFilter from './encodeUri';
import inlineFilter from './inline';
import jpDateFilter from './jp-date';
import locFilter from './loc';
import propFilter from './prop';
import strParamsFilter from './str-params';
import wordsFilter from './words';
import asyncFilter from './async.filter';
import urlToLinkFilter from './url-to-link-filter';

/**
 * @ngdoc module
 * @name portaro.filters
 * @module portaro.filters
 */

export default register('portaro.filters')
    .filter(recordDetailPathFilter.filterName, recordDetailPathFilter)
    .filter(bytesFilter.filterName, bytesFilter)
    .filter(charactersFilter.filterName, charactersFilter)
    .filter(comma2decimalFilter.filterName, comma2decimalFilter)
    .filter(decimal2commaFilter.filterName, decimal2commaFilter)
    .filter(defaultFilter.filterName, defaultFilter)
    .filter(encodeUriFilter.filterName, encodeUriFilter)
    .filter(inlineFilter.filterName, inlineFilter)
    .filter(jpDateFilter.filterName, jpDateFilter)
    .filter(locFilter.filterName, locFilter)
    .filter(propFilter.filterName, propFilter)
    .filter(strParamsFilter.filterName, strParamsFilter)
    .filter(urlToLinkFilter.filterName, urlToLinkFilter)
    .filter(wordsFilter.filterName, wordsFilter)
    .filter(asyncFilter.filterName, asyncFilter)
    .name();
